import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-mini-square-bar',
  templateUrl: './mini-square-bar.component.html',
  styleUrls: ['./mini-square-bar.component.scss']
})
export class MiniSquareBarComponent implements OnInit {

  @Input() openCalls: number;
  @Input() ongoingCalls: number;
  @Input() pendingCalls: number;
  @Input() thisMonthCalls: number;
  @Input() closedTodayCalls: number;

  constructor() { }

  ngOnInit(): void {
  }

  public countCalls() {
  }
}
